module.exports = __webpack_public_path__ + "static/media/phone2.617100df.png";